const application = {
	pageNotFound: "Page not found",
	toFrontpage: "To frontpage"
} as const;

export default application;
